import { Row, Typography } from "antd";
import { useState } from "react";
import Partners from "./partners";

const OverseasProducts = () => {
  const [activeSection, setActiveSection] = useState("section1");

  const toggleSection = (sectionName) => {
    setActiveSection(sectionName);
  };

  return (
    <div className="max-w-screen text-left">
      <div className="relative hidden w-screen bg-center bg-cover lg:block max-w-screen max-w-full">
        <img src="/assets/images/overseas-tab/overseasBG.png" alt="image-" />
        <div className="absolute top-0 flex items-center justify-between w-full h-full">
          <div className="w-2/3 h-full max-w-screen">
            <div
              className={`h-full sectionAero ${
                activeSection === "section1" ? "block" : "hidden"
              }`}
            >
              <div className="flex items-center h-full">
                <div className="flex items-end w-1/3 h-full">
                  <img
                    src="/assets/images/overseas-tab/epdm-tab.png"
                    alt="EPDM Profiles"
                  />
                </div>
                <div className="flex items-center justify-start w-2/3 h-full px-4 py-16 ">
                  <div className="flex flex-col w-2/3 gap-4 ">
                    <Typography.Title
                      level={2}
                      className="font-semibold border-b-2 border-[#C21616] w-fit"
                    >
                      Overseas Products
                    </Typography.Title>
                    <h1 className="text-left text-[#343A40] font-semibold">
                      EPDM Profiles
                    </h1>
                    <p className="w-3/3 text-xs text-[#5F6973] text-left">
                      Being a pioneer in Polymer products, ALP Overseas has an
                      expertise of over 35 years in developing long lasting &
                      functional EPDM profiles. Our seals and profiles for
                      automotive and Building and construction industries are
                      available in different colours, material extrusions and
                      with various application options to suit different
                      requirements.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div
              className={`h-full sectionAero ${
                activeSection === "acoustic" ? "block" : "hidden"
              }`}
            >
              <div className="flex items-end h-full">
                <div className="flex items-end w-1/3 h-full">
                  <img
                    src="/assets/images/overseas-tab/silicon.png"
                    alt="EPDM Profiles"
                  />
                </div>
                <div className="flex items-center justify-start w-2/3 h-full px-4 py-16 ">
                  <div className="flex flex-col w-2/3 gap-4 ">
                    <Typography.Title
                      level={2}
                      className="font-semibold border-b-2 border-[#C21616] w-fit"
                    >
                      Overseas Products
                    </Typography.Title>
                    <h1 className="text-base text-[#343A40] font-semibold">
                      Silicon Gel Pad
                    </h1>
                    <p className="w-3/3 text-xs text-[#5F6973]">
                      Being a pioneer in Polymer products, ALP Overseas has an
                      expertise of over 35 years in developing long lasting &
                      functional EPDM profiles. Our seals and profiles for
                      automotive and Building and construction industries are
                      available in different colours, material extrusions and
                      with various application options to suit different
                      requirements.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div
              className={`h-full sectionAero ${
                activeSection === "tapes" ? "block" : "hidden"
              }`}
            >
              <div className="flex items-end h-full">
                <div className="flex items-end w-1/3 h-full">
                  <img
                    src="/assets/images/overseas-tab/pvc.png"
                    alt="EPDM Profiles"
                  />
                </div>
                <div className="flex items-center justify-start w-2/3 h-full px-4 py-16 ">
                  <div className="flex flex-col w-2/3 gap-4 ">
                    <Typography.Title
                      level={2}
                      className="font-semibold border-b-2 border-[#C21616] w-fit"
                    >
                      Overseas Products
                    </Typography.Title>
                    <h1 className="text-base text-[#343A40] font-semibold">
                      PVC/TPE/TPO/TPR/ABS
                    </h1>
                    <p className="w-3/3 text-xs text-[#5F6973]">
                      All the molded products in this range serve multiple
                      requirements across Passenger vehicles, LCV & HCVs. This
                      range also include products which are used across various
                      industrial applications, buildings and Refrigeration
                      industry as well.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div
              className={`h-full sectionAero ${
                activeSection === "granule" ? "block" : "hidden"
              }`}
            >
              <div className="flex items-end h-full">
                <div className="flex items-end w-1/3 h-full">
                  <img
                    src="/assets/images/overseas-tab/rigid.png"
                    alt="EPDM Profiles"
                  />
                </div>
                <div className="flex items-center justify-start w-2/3 h-full px-4 py-16 ">
                  <div className="flex flex-col w-2/3 gap-4 ">
                    <Typography.Title
                      level={2}
                      className="font-semibold border-b-2 border-[#C21616] w-fit"
                    >
                      Overseas Products
                    </Typography.Title>
                    <h1 className="text-base text-[#343A40] font-semibold">
                      RIGID/Soft PVC Products
                    </h1>
                    <p className="w-3/3 text-xs text-[#5F6973]">
                      ALP’s PVC Rigid and Soft Profiles are being used worldwide
                      in building construction, automobile, and industrial
                      segment. These profiles are manufactured by experts using
                      modern technology and the best quality of polyvinyl
                      chloride. These products can be manufactured or customized
                      according to the demands of the clients. All our products
                      are tested on multiple parameters to ensure best quality.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div
              className={`h-full sectionAero ${
                activeSection === "mat" ? "block" : "hidden"
              }`}
            >
              <div className="flex items-end h-full">
                <div className="flex items-end w-1/3 h-full">
                  <img
                    src="/assets/images/overseas-tab/epdm-mat.png"
                    alt="EPDM Profiles"
                  />
                </div>
                <div className="flex items-center justify-start w-2/3 h-full px-4 py-16 ">
                  <div className="flex flex-col w-2/3 gap-4 ">
                    <Typography.Title
                      level={2}
                      className="font-semibold border-b-2 border-[#C21616] w-fit"
                    >
                      Overseas Products
                    </Typography.Title>
                    <h1 className="text-base text-[#343A40] font-semibold">
                      EPDM Mats and Color Granules
                    </h1>
                    <p className="w-3/3 text-xs text-[#5F6973]">
                      Being a pioneer in Polymer technology, ALP Overseas has an
                      expertise in EPDM Products and this Versatile range of
                      Mats and Granules serve multiple purposes across
                      industries. The Company is fully capable to customize
                      these products to suit specific project requirements.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="flex flex-col items-start justify-between w-1/3 gap-4 p-8 tab pl-36">
            <button
              className={`section-link text-base text-white border-b-2 border-b-[white] ${
                activeSection === "section1" ? "active" : ""
              }`}
              style={{ paddingBottom: "5px", backgroundColor: "transparent" }}
              onClick={() => toggleSection("section1")}
            >
              EPDM Profiles
            </button>
            <button
              className={`section-link text-base text-white border-b-2 border-b-[white] ${
                activeSection === "acoustic" ? "active" : ""
              }`}
              style={{ paddingBottom: "5px", backgroundColor: "transparent" }}
              onClick={() => toggleSection("acoustic")}
            >
              Silicon Gel Pad
            </button>
            <button
              className={`section-link text-base text-white border-b-2 border-b-[white] ${
                activeSection === "tapes" ? "active" : ""
              }`}
              style={{ paddingBottom: "5px", backgroundColor: "transparent" }}
              onClick={() => toggleSection("tapes")}
            >
              PVC/TPE/TPO/TPR/ABS
            </button>
            <button
              className={`section-link text-base text-white border-b-2 border-b-[white] ${
                activeSection === "granule" ? "active" : ""
              }`}
              style={{ paddingBottom: "5px", backgroundColor: "transparent" }}
              onClick={() => toggleSection("granule")}
            >
              RIGID/Soft PVC Products
            </button>
            <button
              className={`section-link text-base text-white border-b-2 border-b-[white] text-left ${
                activeSection === "mat" ? "active" : ""
              }`}
              style={{ paddingBottom: "5px", backgroundColor: "transparent" }}
              onClick={() => toggleSection("mat")}
            >
              EPDM Mats and Color Granules
            </button>
          </div>
        </div>
      </div>

      {/* Overseas Products Accordion */}
      <div className="block lg:hidden pt-8">
        <div className="flex items-center justify-center w-full mt-2 mb-6">
          <p className="w-10/12 text-[25px] font-semibold leading-6 text-center text-[#343A40]">
            Overseas Products
          </p>
        </div>

        <div className="flex flex-col items-center justify-center w-full gap-2 pb-4 accordion">
          <div className="w-10/12">
            <button
              className={`px-4 rounded-md flex items-center justify-between w-full py-4 text-sm font-semibold text-left text-white bg-[#C21616] ${
                activeSection === "section1" ? "active" : ""
              }`}
              onClick={() => toggleSection("section1")}
            >
              <span>EPDM Profiles</span>
              <img
                src="/assets/images/arrow-down.svg"
                className="w-[16px]"
                alt="Expand"
              />
            </button>
            <div
              className={`overflow-hidden transition-all duration-300 ${
                activeSection === "section1" ? "max-h-screen" : "max-h-0"
              }`}
            >
              <div
                className="flex flex-col items-center justify-center gap-2 py-4 h-min bg-contain bg-right bg-no-repeat"
                style={{
                  backgroundImage:
                    "url('/assets/images/overseas-tab/mob-bg.png')",
                }}
              >
                <Typography.Title level={5} className="text-left w-full">
                  EPDM Profiles
                </Typography.Title>
                <p className="text-xs text-[#5F6973]">
                  Being a pioneer in Polymer products, ALP Overseas has an
                  expertise of over 35 years in developing long lasting &
                  functional EPDM profiles. Our seals and profiles for
                  automotive and Building and construction industries are
                  available in different colours, material extrusions and with
                  various application options to suit different requirements.
                </p>
              </div>
            </div>
          </div>

          <div className="w-10/12">
            <button
              className={`px-4 rounded-md flex items-center justify-between w-full py-4 text-sm font-semibold text-left text-white bg-[#C21616] ${
                activeSection === "acoustic" ? "active" : ""
              }`}
              onClick={() => toggleSection("acoustic")}
            >
              <span>Silicon Gel Pad</span>
              <img
                src="/assets/images/arrow-down.svg"
                className="w-[16px]"
                alt="Expand"
              />
            </button>
            <div
              className={`overflow-hidden transition-all duration-300 ${
                activeSection === "acoustic" ? "max-h-screen" : "max-h-0"
              }`}
            >
              <div
                className="flex flex-col items-center justify-center gap-2 py-4 h-min bg-contain bg-right bg-no-repeat bg-opacity-90"
                style={{
                  backgroundImage:
                    "url('/assets/images/overseas-tab/mob-bg.png')",
                }}
              >
                <Typography.Title level={5} className="text-left w-full">
                  Silicon Gel Pad
                </Typography.Title>
                <p className="text-xs text-[#5F6973]">
                  Being a pioneer in Polymer products, ALP Overseas has an
                  expertise of over 35 years in developing long lasting &
                  functional EPDM profiles. Our seals and profiles for
                  automotive and Building and construction industries are
                  available in different colours, material extrusions and with
                  various application options to suit different requirements.
                </p>
              </div>
            </div>
          </div>

          <div className="w-10/12">
            <button
              className={`px-4 rounded-md flex items-center justify-between w-full py-4 text-sm font-semibold text-left text-white bg-[#C21616] ${
                activeSection === "tapes" ? "active" : ""
              }`}
              onClick={() => toggleSection("tapes")}
            >
              <span>PVC/TPE/TPO/TPR/ABS</span>
              <img
                src="/assets/images/arrow-down.svg"
                className="w-[16px]"
                alt="Expand"
              />
            </button>
            <div
              className={`overflow-hidden transition-all duration-300 ${
                activeSection === "tapes" ? "max-h-screen" : "max-h-0"
              }`}
            >
              <div
                className="flex flex-col items-center justify-center gap-2 py-4 h-min bg-contain bg-right bg-no-repeat bg-opacity-90"
                style={{
                  backgroundImage:
                    "url('/assets/images/overseas-tab/mob-bg.png')",
                }}
              >
                <Typography.Title level={5} className="text-left w-full">
                  PVC/TPE/TPO/TPR/ABS
                </Typography.Title>
                <p className="text-xs text-[#5F6973]">
                  All the molded products in this range serve multiple
                  requirements across Passenger vehicles, LCV & HCVs. This range
                  also include products which are used across various industrial
                  applications, buildings and Refrigeration industry as well.
                </p>
              </div>
            </div>
          </div>

          <div className="w-10/12">
            <button
              className={`px-4 rounded-md flex items-center justify-between w-full py-4 text-sm font-semibold text-left text-white bg-[#C21616] ${
                activeSection === "granule" ? "active" : ""
              }`}
              onClick={() => toggleSection("granule")}
            >
              <span>RIGID/Soft PVC Products</span>
              <img
                src="/assets/images/arrow-down.svg"
                className="w-[16px]"
                alt="Expand"
              />
            </button>
            <div
              className={`overflow-hidden transition-all duration-300 ${
                activeSection === "granule" ? "max-h-screen" : "max-h-0"
              }`}
            >
              <div
                className="flex flex-col items-center justify-center gap-2 py-4 h-min bg-contain bg-right bg-no-repeat bg-opacity-90"
                style={{
                  backgroundImage:
                    "url('/assets/images/overseas-tab/mob-bg.png')",
                }}
              >
                <Typography.Title level={5} className="text-left w-full">
                  RIGID/Soft PVC Products
                </Typography.Title>
                <p className="text-xs text-[#5F6973]">
                  ALP’s PVC Rigid and Soft Profiles are being used worldwide in
                  building construction, automobile, and industrial segment.
                  These profiles are manufactured by experts using modern
                  technology and the best quality of polyvinyl chloride. These
                  products can be manufactured or customized according to the
                  demands of the clients. All our products are tested on
                  multiple parameters to ensure best quality.
                </p>
              </div>
            </div>
          </div>

          <div className="w-10/12">
            <button
              className={`px-4 rounded-md flex items-center justify-between w-full py-4 text-sm font-semibold text-left text-white bg-[#C21616] ${
                activeSection === "mat" ? "active" : ""
              }`}
              onClick={() => toggleSection("mat")}
            >
              <span>EPDM Mats and Color Granules</span>
              <img
                src="/assets/images/arrow-down.svg"
                className="w-[16px] text-white"
                alt="Expand"
              />
            </button>
            <div
              className={`overflow-hidden transition-all duration-300 ${
                activeSection === "mat" ? "max-h-screen" : "max-h-0"
              }`}
            >
              <div
                className="flex flex-col items-center justify-center gap-2 py-4 h-min bg-contain bg-right bg-no-repeat bg-opacity-90"
                style={{
                  backgroundImage:
                    "url('/assets/images/overseas-tab/mob-bg.png')",
                }}
              >
                <Typography.Title level={5} className="text-left w-full">
                  EPDM Mats and Color Granules
                </Typography.Title>
                <p className="text-xs text-[#5F6973]">
                  Being a pioneer in Polymer technology, ALP Overseas has an
                  expertise in EPDM Products and this Versatile range of Mats
                  and Granules serve multiple purposes across industries. The
                  Company is fully capable to customize these products to suit
                  specific project requirements.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Row className="lg:hidden">
        <Partners />
      </Row>
    </div>
  );
};

export default OverseasProducts;
